import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Modal, ModalCTA } from 'containers/misc'
import { Title } from 'components/layout'
import { List, Button } from 'components/misc'
import config from 'config'

const listActions = [
  {
    id: 1,
    label: 'Remove',
    intlKey: 'button.remove',
    action: 'removeAjEvent',
    url: `${config.publicPath}/`
  }
]

export default class AJEventSettingsModal extends Component {
  static propTypes = {
    data: PropTypes.object,
    modalId: PropTypes.string.isRequired,
    modal: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    isTemplate: PropTypes.bool
  }

  static defaultProps = {
    data: {}
  }

  state = {
    removeAjEvent: false
  }

  handleSubDialogOpen = action => {
    this.setState({
      removeAjEvent: action === 'removeAjEvent'
    })
  }

  handleDialogClose = () =>
    this.setState({
      removeAjEvent: false
    })

  render() {
    const { modalId, data, isTemplate } = this.props
    const { removeAjEvent } = this.state

    const titleIntl = isTemplate
      ? 'moduleTitle.adventurous_journey_template_settings'
      : 'moduleTitle.adventurous_journey_settings'

    const defaultMessage = isTemplate
      ? 'Adventurous journey template settings'
      : 'Adventurous journey settings'

    return (
      <Modal id={modalId} customActions>
        <Title h2 intlKey={titleIntl}>
          {defaultMessage}
        </Title>
        <div className="base-margin--bottom">
          <List data={listActions} onSelect={this.handleSubDialogOpen} />
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Button
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
              secondary
            >
              Close
            </Button>
          </div>
        </div>
        {removeAjEvent &&
          <ModalCTA>
            <div className="row">
              <div className="col-xs-12">
                <Title
                  h2
                  className="text--center"
                  intlKey="moduleTitle.are_you_sure"
                >
                  Are you sure?
                </Title>
              </div>
              <div className="col-xs-6">
                <Button
                  type="button"
                  onClick={this.handleDialogClose}
                  intlKey="button.close"
                  secondary
                >
                  Close
                </Button>

              </div>
              <div className="col-xs-6 text--right">
                <Button
                  type="button"
                  negative
                  intlKey="button.remove"
                  onClick={() => this.props.onDelete(get(data, 'detail.id'))}
                >
                  Remove
                </Button>
              </div>
            </div>
          </ModalCTA>}
      </Modal>
    )
  }
}
